import React, { useEffect } from "react";
import s from "./style.module.scss";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { popupSelect } from "shared/redux/selectors/popup";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";

const Popup: React.FC = () => {
  const { pathname } = useLocation();
  const { content, open } = useAppSelector(popupSelect);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setOpen(false));
    dispatch(setContent(null));
  };

  useEffect(() => {
    if (open) document?.body.classList.add("lock");
    else document?.body.classList.remove("lock");
  }, [open]);

  useEffect(() => {
    // handleClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      {open && (
        <div className={s.popup} onMouseDown={handleClose}>
          <div onMouseDown={(e) => e.stopPropagation()} className={s.content}>
            {content}
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
